<div>
  <button class="uk-button uk-width-1-1 text-center uk-padding-remove-horizontal"
          [class.uk-button-primary]="cardName === activeCardName" (click)="click()">
    <span>{{text}}</span>
  </button>
</div>
